export const FETCH_APPLICANTS_RECENT_APPLICATION = 'FETCH_APPLICANTS_RECENT_APPLICATION'
export const FETCH_APPLICANTS_PROGRAM_COUNTDOWN = 'FETCH_APPLICANTS_PROGRAM_COUNTDOWN'